var map = {
	"./content/book": 250,
	"./content/book.json": 250,
	"./content/book.yaml": 1345,
	"./content/figures/m/map-afghanistan-transition.svg": 1346,
	"./content/figures/m/map-bm-afghanistan-2005-2014.svg": 1347,
	"./content/figures/m/map-figure-11-1.svg": 1348,
	"./content/figures/m/map-figure-11-5.svg": 1349,
	"./content/figures/m/map-figure-11-7.svg": 1350,
	"./content/figures/m/map-figure-12-2.svg": 1351,
	"./content/figures/m/map-figure-13-1.svg": 1352,
	"./content/figures/m/map-figure-13-4.svg": 1353,
	"./content/figures/m/map-figure-2-2.svg": 1354,
	"./content/figures/m/map-figure-2-5.svg": 1355,
	"./content/figures/m/map-figure-2-8.svg": 1356,
	"./content/figures/m/map-figure-3-2.svg": 1357,
	"./content/figures/m/map-figure-3-4.svg": 1358,
	"./content/figures/m/map-figure-3-5.svg": 1359,
	"./content/figures/m/map-figure-3-7.svg": 1360,
	"./content/figures/m/map-figure-3-9.svg": 1361,
	"./content/figures/m/map-figure-4-2.svg": 1362,
	"./content/figures/m/map-figure-4-4.svg": 1363,
	"./content/figures/m/map-figure-4-5.svg": 1364,
	"./content/figures/m/map-figure-5-2.svg": 1365,
	"./content/figures/m/map-figure-5-6.svg": 1366,
	"./content/figures/m/map-figure-5-m.svg": 1367,
	"./content/figures/m/map-figure-6-1.svg": 1368,
	"./content/figures/m/map-figure-6-3.svg": 1369,
	"./content/figures/m/map-figure-6-m.svg": 1370,
	"./content/figures/m/map-figure-7-4.svg": 1371,
	"./content/figures/m/map-figure-7-7.svg": 1372,
	"./content/figures/m/map-figure-7-m.svg": 1373,
	"./content/figures/m/map-figure-8-1.svg": 1374,
	"./content/figures/m/map-figure-8-11.svg": 1375,
	"./content/figures/m/map-figure-8-2.svg": 1376,
	"./content/figures/m/map-figure-8-5.svg": 1377,
	"./content/figures/m/map-figure-8-9.svg": 1378,
	"./content/figures/m/map-figure-9-4.svg": 1379,
	"./content/figures/m/map-figure-9-5.svg": 1380,
	"./content/figures/m/map-fm-AfghanistanProvincialBoundaries.svg": 1381,
	"./content/figures/m/map-s2-helmand-and-kandahar.svg": 1382,
	"./content/figures/v2/Img_7-4.svg": 1383,
	"./content/figures/v2/OEF_CVR2.png": 1384,
	"./content/figures/v2/art_14-2.png": 1385,
	"./content/figures/v2/art_S3-1.png": 1386,
	"./content/figures/v2/art_sII-1.png": 1387,
	"./content/figures/v2/grafik_9-4.png": 1388,
	"./content/figures/v2/grafik_Fig1-1.png": 1389,
	"./content/figures/v2/grafik_Fig1-6.png": 1390,
	"./content/figures/v2/img_1-1.png": 1391,
	"./content/figures/v2/img_1-3.png": 1392,
	"./content/figures/v2/img_1-4.png": 1393,
	"./content/figures/v2/img_1-5.png": 1394,
	"./content/figures/v2/img_10-1.png": 1395,
	"./content/figures/v2/img_10-2.png": 1396,
	"./content/figures/v2/img_10-3.png": 1397,
	"./content/figures/v2/img_11-1.png": 1398,
	"./content/figures/v2/img_11-2.png": 1399,
	"./content/figures/v2/img_11-3.png": 1400,
	"./content/figures/v2/img_11-4.png": 1401,
	"./content/figures/v2/img_11-5.png": 1402,
	"./content/figures/v2/img_11-6.png": 1403,
	"./content/figures/v2/img_12-1.png": 1404,
	"./content/figures/v2/img_12-2.png": 1405,
	"./content/figures/v2/img_12-3.png": 1406,
	"./content/figures/v2/img_13-1.png": 1407,
	"./content/figures/v2/img_13-2.png": 1408,
	"./content/figures/v2/img_13-3.png": 1409,
	"./content/figures/v2/img_13-4.png": 1410,
	"./content/figures/v2/img_14-1.png": 1411,
	"./content/figures/v2/img_2-1.png": 1412,
	"./content/figures/v2/img_2-2.png": 1413,
	"./content/figures/v2/img_2-3.png": 1414,
	"./content/figures/v2/img_2-4.png": 1415,
	"./content/figures/v2/img_3-1.png": 1416,
	"./content/figures/v2/img_3-2.png": 1417,
	"./content/figures/v2/img_3-3.png": 1418,
	"./content/figures/v2/img_3-4.png": 1419,
	"./content/figures/v2/img_3-5.png": 1420,
	"./content/figures/v2/img_4-1.png": 1421,
	"./content/figures/v2/img_4-2.png": 1422,
	"./content/figures/v2/img_4-3.png": 1423,
	"./content/figures/v2/img_4-4.png": 1424,
	"./content/figures/v2/img_5-1.png": 1425,
	"./content/figures/v2/img_5-2.png": 1426,
	"./content/figures/v2/img_5-3.png": 1427,
	"./content/figures/v2/img_5-4a.png": 1428,
	"./content/figures/v2/img_5-4b.png": 1429,
	"./content/figures/v2/img_5-5.png": 1430,
	"./content/figures/v2/img_6-1.png": 1431,
	"./content/figures/v2/img_6-2.png": 1432,
	"./content/figures/v2/img_6-3.png": 1433,
	"./content/figures/v2/img_7-1.png": 1434,
	"./content/figures/v2/img_7-2.png": 1435,
	"./content/figures/v2/img_7-2.svg": 1436,
	"./content/figures/v2/img_7-3.png": 1437,
	"./content/figures/v2/img_7-5.png": 1438,
	"./content/figures/v2/img_7-6.png": 1439,
	"./content/figures/v2/img_8-1.png": 1440,
	"./content/figures/v2/img_8-2.png": 1441,
	"./content/figures/v2/img_8-3.png": 1442,
	"./content/figures/v2/img_8-4.png": 1443,
	"./content/figures/v2/img_8-5.png": 1444,
	"./content/figures/v2/img_8-6.png": 1445,
	"./content/figures/v2/img_8-7.png": 1446,
	"./content/figures/v2/img_9-1.png": 1447,
	"./content/figures/v2/img_9-2.png": 1448,
	"./content/figures/v2/img_9-3.png": 1449,
	"./content/figures/v2/img_9-5.png": 1450,
	"./content/figures/v2/img_cvr_oef2.png": 1451,
	"./content/figures/v2/img_sII-2.png": 1452,
	"./content/figures/v2/map_11-3.svg": 1453,
	"./content/figures/v2/map_2-1.svg": 1454,
	"./content/figures/v2/map_2-2.svg": 1455,
	"./content/figures/v2/map_2-3.svg": 1456,
	"./content/figures/v2/map_3-1.svg": 1457,
	"./content/figures/v2/map_3-2.svg": 1458,
	"./content/figures/v2/map_3-3.svg": 1459,
	"./content/figures/v2/map_3-4.svg": 1460,
	"./content/figures/v2/map_3-5.svg": 1461,
	"./content/figures/v2/map_4-1.svg": 1462,
	"./content/figures/v2/map_4-2.svg": 1463,
	"./content/figures/v2/map_4-3.svg": 1464,
	"./content/figures/v2/map_5-1.svg": 1465,
	"./content/figures/v2/map_5-2.svg": 1466,
	"./content/figures/v2/map_5-3.svg": 1467,
	"./content/figures/v2/map_6-1.svg": 1468,
	"./content/figures/v2/map_6-2.svg": 1469,
	"./content/figures/v2/map_7-1.svg": 1470,
	"./content/figures/v2/map_7-3.svg": 1471,
	"./content/figures/v2/map_SIII-1.svg": 1472,
	"./content/figures/v2/map_sII-1.svg": 1473,
	"./content/iframe/ch14/VOLII_Ch14Conclusionv2.html": 1474,
	"./content/iframe/ch2/OEF_VII_Ch_2_v2.html": 1475,
	"./content/logo.svg": 1476,
	"./content/media/audio.example.mp3": 1477,
	"./content/media/media.example.poster.png": 1478,
	"./content/media/video.example.mp4": 1479
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1344;


//////////////////
// WEBPACK FOOTER
// ./src ./node_modules/html-loader ^\.\/content.*$
// module id = 1344
// module chunks = 0